import React from 'react'
import { Card } from 'semantic-ui-react'

import User from "./user"


const Users = ({users, onEditUser, onDeleteUser, formConfigData}) => {

return (
      <>
      
        <Card.Group
          itemsPerRow={ (users && (users.length <= 2)) ? 2 : 3}
          stackable
        >
              {
                users && users.map((user, index) => {
                 return  <User 
                      key={user.key}
                      user={user} 
                      onEditUser={onEditUser} 
                      onDeleteUser={onDeleteUser}
                      formConfigData={formConfigData}                      
                    />
                }
                
                )
              }
        </Card.Group>
      
      </>
    )
}

export default Users;



